import React from "react";
import Img from "components/image";
import styles from "./image.module.scss";

const Image = ({ image }) => {
  return <Img {...image[0].optimized} className={styles.image} />;
};

export default Image;
